import React from 'react'

import RectLoader from '_components/rect-loader/index.jsx'
import DomainsRow from '../domains-row/index.jsx'

import './styles.scss'

const DomainsCard = ({ isLoading, topDomains, totalEvents, hideDescriptions }) => {
  return (
    <div className="highlights-domains-table__container">
      <table className="highlights-domains-table">
        <thead className="highlights-domains-table__head">
          <tr className="highlights-domains-table__row head">
            <th className="highlights-domains-table__header-cell">&nbsp;</th>
            <th className="highlights-domains-table__header-cell left">Domain</th>
            <th className="highlights-domains-table__header-cell left">Categories</th>
            <th className="highlights-domains-table__header-cell">Total Users</th>
            <th className="highlights-domains-table__header-cell">Total Events</th>
            <th className="highlights-domains-table__header-cell">% of Total Events</th>
            <th className="highlights-domains-table__header-cell">&nbsp;</th>
          </tr>
        </thead>
        <tbody className="highlights-domains-table__body">
          <If condition={isLoading}>
            <For each="item" index="index" of={Object.keys([...Array(10)])}>
              <tr className="highlights-domains-table__row loading">
                <For each="item" index="index" of={Object.keys([...Array(6)])}>
                  <td className="highlights-domains-table__header-cell">
                    <RectLoader width="99%" height="24px" />
                  </td>
                </For>
              </tr>
            </For>
          </If>
          <If condition={!isLoading}>
            <For each="domain" index="index" of={topDomains}>
              <DomainsRow
                index={index}
                key={index}
                domain={domain.domain}
                description={domain.description}
                hideDescriptions={hideDescriptions}
                descriptors={domain.descriptors}
                industries={domain.industries}
                categories={domain.categories}
                size={domain.size}
                totalEvents={totalEvents}
                totalUsers={domain.users}
                deviceTypes={domain.deviceTypes}
                eventTypes={domain.eventTypes}
                urls={domain.urls}
              />
            </For>
          </If>
        </tbody>
      </table>
    </div>
  )
}

export default DomainsCard
